import Vue from 'vue';
import VueRouter from 'vue-router';
import homeRoutes from './routes/home';
import seoRoutes from './routes/soi';
import nutritionRoutes from './routes/nutrition';
import ecommerceRoutes from './routes/ecommerce';
import homeImprovementRoutes from './routes/homeImprovement';
import loanRoutes from './routes/loans';
import miscRoutes from './routes/misc';

Vue.use(VueRouter);

const routes = [
  ...homeRoutes,
  ...seoRoutes,
  ...nutritionRoutes,
  ...ecommerceRoutes,
  ...homeImprovementRoutes,
  ...loanRoutes,
  ...miscRoutes,
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
